import { useMemo } from 'react'
import { useSWRWithCache } from '@signal/core/swr'
import getAPIDomain from '@signal/utils/env/apiDomain'
import isStorybook from '@signal/utils/env/isStorybook'
import isTest from '@signal/utils/env/isTest'
import { GenericFetchHookParamsType } from '../contextFetch'
import mockData from './mockData.json'
import { LicenseInformationRecordType } from './types'

export function getLicenseInformation(): string {
  return `${getAPIDomain('/dev-ops/api')}/v1/license-attribution`
}

/**
 * this is a wrapper around useSWRWithCache that can be used to fetch the license data
 * @return {LicenseInformationRecordType | undefined} - returns undefined unless the data has been fetched,
 *   in which case the license data is returned
 */
export function useLicenseInformation({
  ...rest
}: GenericFetchHookParamsType):
  | Array<LicenseInformationRecordType>
  | undefined {
  const url = useMemo(() => getLicenseInformation(), [])
  return useSWRWithCache({
    cacheBust: true,
    context: 'useLicenseInformation',
    url,
    useMockData: isTest() || isStorybook(),
    mockData: mockData,
    ...rest
  })
}
